import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles({
  // Document banner container
  surveyHeaderContainer: {},
  // Exit-link container
  surveyToolbarContainer: {},
  // Logo container
  surveyLogoContainer: {},
  // Survey Title container
  surveyTitleContainer: {},
  // Page Header container
  pageHeaderContainer: {},
  // Form
  questionContainer: {},
  // Page Footer Container
  pageFooterContainer: {},
  // May not be used
  surveyFooterContainer: {},
});

export default useStyles;
